var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenPocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2631_9625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3623 0H-3.22888V48H49.3623V0Z",
    fill: "#2980FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1221 20.561H18.1285C18.1221 20.5242 18.1221 20.4812 18.1221 20.4443V20.561Z",
    fill: "#29AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9586 21.7285H23.8538V33.9415C23.8538 34.5186 24.3437 34.9853 24.9498 34.9853H29.8626C30.4687 34.9853 30.9586 34.5186 30.9586 33.9415V21.7285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4238 12.9844H20.1853H7.46483C6.85875 12.9844 6.36877 13.451 6.36877 14.0282V18.265C6.36877 18.8422 6.85875 19.3088 7.46483 19.3088H10.4499H11.6362V20.5614V33.9718C11.6362 34.549 12.1262 35.0156 12.7322 35.0156H17.4001C18.0061 35.0156 18.4961 34.549 18.4961 33.9718V20.5614V20.4448V19.3088H19.6824H20.1659H20.4045C22.2355 19.3088 23.7248 17.8905 23.7248 16.1466C23.7442 14.4028 22.2549 12.9844 20.4238 12.9844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9651 21.7285V30.2512C31.2101 30.3065 31.4615 30.3494 31.7194 30.3863C32.0805 30.4354 32.4544 30.4661 32.8284 30.4722C32.8477 30.4722 32.867 30.4722 32.8928 30.4722V23.6934C31.8161 23.6258 30.9651 22.7723 30.9651 21.7285Z",
    fill: "url(#paint0_linear_2631_9625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0346 12.9844C27.9671 12.9844 23.8538 16.9019 23.8538 21.7281C23.8538 25.8789 26.8904 29.3543 30.9651 30.2508V21.7281C30.9651 20.6413 31.8935 19.7571 33.0346 19.7571C34.1758 19.7571 35.1042 20.6413 35.1042 21.7281C35.1042 22.643 34.4531 23.4105 33.5633 23.6316C33.3957 23.6745 33.2152 23.6991 33.0346 23.6991V30.4718C33.2152 30.4718 33.3893 30.4657 33.5633 30.4596C38.3859 30.1955 42.2156 26.3886 42.2156 21.7281C42.222 16.9019 38.1086 12.9844 33.0346 12.9844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0345 30.4722V23.6995C32.9829 23.6995 32.9378 23.6995 32.8862 23.6934V30.4722C32.9378 30.4722 32.9894 30.4722 33.0345 30.4722Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2631_9625",
    x1: 33.0376,
    y1: 26.1017,
    x2: 30.966,
    y2: 26.1017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9667,
    stopColor: "white",
    stopOpacity: 0.3233
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2631_9625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenPocket);
export default __webpack_public_path__ + "static/media/token-pocket.1e15d11f5157b7c6a8708498519167c1.svg";
export { ForwardRef as ReactComponent };